import type { Crumb } from '../../lib/crumbs';
import { SETTINGS_PATH } from '../../lib/nav';

/** Крошки раздела «Настроек»: «Настройки / <раздел>» и дальше (ux.md §11). «Настройки» — без ссылки, как в прототипе. */
export function settingsCrumbs(...rest: Crumb[]): Crumb[] {
  return [{ label: 'Настройки' }, ...rest];
}

/** Крошка «Площадки» на странице площадки — ссылка на список: «Настройки / Площадки / <название>». */
export const SITES_CRUMB: Crumb = { label: 'Площадки', to: SETTINGS_PATH.sites };
